// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@expo/webpack-config/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "video {\n  width: 100%;\n  height: 100%;\n}\ndiv[data-testid=\"native.calendar.CHANGE_MONTH_LEFT_ARROW\"] img {\n  position: initial;\n}\ndiv[data-testid=\"native.calendar.CHANGE_MONTH_RIGHT_ARROW\"] img {\n  position: initial;\n}\n", ""]);
// Exports
module.exports = exports;
